import axios from 'axios';

/**
 * Extrai mensagem de erro da resposta do backend para exibir em toast.
 * Prioriza: message (string ou array), error, errors[], statusText.
 * Se message for array (ex.: validação), junta com " • ".
 */
export function getErrorMessage(err: unknown, fallback: string): string {
	if (!axios.isAxiosError(err) || !err.response?.data) return fallback;
	const data = err.response.data as Record<string, unknown>;
	const rawMessage = data.message;
	if (Array.isArray(rawMessage) && rawMessage.length > 0) {
		const parts = rawMessage.filter(
			(m): m is string => typeof m === 'string',
		);
		return parts.length > 0 ? parts.join(' • ') : fallback;
	}
	if (typeof rawMessage === 'string' && rawMessage.trim())
		return rawMessage.trim();
	if (typeof data.error === 'string' && data.error.trim())
		return data.error.trim();
	if (Array.isArray(data.errors) && data.errors.length > 0) {
		const first = data.errors[0];
		if (typeof first === 'string') return first;
		if (
			first &&
			typeof first === 'object' &&
			typeof (first as { message?: string }).message === 'string'
		)
			return (first as { message: string }).message;
	}
	const statusMsg = err.response.statusText;
	if (statusMsg) return `${err.response.status}: ${statusMsg}`;
	return fallback;
}

/** Mensagem crua do backend, sem fallback genérico. */
export function getBackendErrorMessage(error: unknown): string | null {
	if (!axios.isAxiosError(error) || error.response?.data == null) return null;
	const data = error.response.data;
	if (typeof data === 'string' && data.trim()) return data.trim();
	if (typeof data !== 'object' || data === null) return null;
	const record = data as Record<string, unknown>;
	const rawMessage = record.message;
	if (typeof rawMessage === 'string' && rawMessage.trim())
		return rawMessage.trim();
	if (Array.isArray(rawMessage)) {
		const parts = rawMessage.filter(
			(m): m is string => typeof m === 'string',
		);
		if (parts.length > 0) return parts.join(' • ');
	}
	if (typeof record.error === 'string' && record.error.trim()) {
		return record.error.trim();
	}
	return null;
}
